import request from "../../../api/request";
import store from "../redux/store";
import api_domain_config from "../constants/common";

//api
let apiUrl = api_domain_config.API_V2_URL;

/**
 * 获取图形验证码
 * @param {object} 请求参数
 */
const requestGetCaptcha = () => {
  const options = {
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "captchas", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求用户注册
 * @param {object} 请求参数
 */
const requestSignUp = params => {
  const options = {
    ...params,
    method: "POST",
    redirect: "follow",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求用户登录
 * @param {object} 请求参数
 */
const requestLogin = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "sessions", options)
      .then(res => {
        if (res.code === 200) {
          authorization = res.data.authorization;
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求退出登录，注销当前authorization
 * @param {object} 请求参数
 */
const requestLogout = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "DELETE",
    headers: {
      authorization: authorization,
    },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "sessions", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求获取邮箱验证码
 * @param {object} 请求参数
 */
const requsetGetCode = params => {
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/verification-code", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求验证邮箱验证码
 * @param {object} 请求参数
 */
const requsetVerifyCode = params => {
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/email-verify", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求重置密码
 * @param {object} 请求参数
 */
const requsetResetPassword = params => {
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/password-reset", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求用户信息
 * @param {object} 请求参数
 */
const requsetGetProfile = params => {
  console.log(params);
  let authorization = store.getState().account.authorization;
  let options = {};
  if (authorization) {
    options = {
      method: "GET",
      headers: { authorization: authorization },
    };
  } else if (params && params.headers && params.headers.authorization) {
    authorization = params.headers.authorization;
    options = {
      method: "GET",
      headers: { authorization: authorization },
    };
  }
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/profile", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户信息
 * @param {object} 请求参数
 */
const requsetChangeProfile = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "POST",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/profile-edit", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户密码
 * @param {object} 请求参数
 */
const requsetChangePassword = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "POST",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/password-change", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求修改用户主题信息
 * @param {object} 请求参数
 */
const requsetChangeAppearance = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "POST",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "preferences", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户主题信息
 * @param {object} 请求参数
 */
const requsetGetAppearance = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "GET",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "preferences", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetSubscription = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "GET",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "accounts/subscription", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetPurchase = params => {
  let authorization = store.getState().account.authorization;
  const options = {
    ...params,
    method: "POST",
    headers: { authorization: authorization },
  };
  return new Promise((resolve, reject) => {
    request(apiUrl + "check-out", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

//===============  Feedback 项目接口，接本项目以外的服务器  ==================

/**
 * 请求Feedback附件上传
 * @param {object} 请求参数
 */
const requestFeedbackUpload = params => {
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request("https://integrated.tenorshare.com/api/v1/upload", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 请求Feedback 用户反馈
 * @param {object} 请求参数
 */
const requestFeedback = params => {
  const options = {
    ...params,
    method: "POST",
  };
  return new Promise((resolve, reject) => {
    request("https://integrated.tenorshare.com/api/v1/ticket/feedback", options)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export {
  requestGetCaptcha,
  requestSignUp,
  requestLogin,
  requestLogout,
  requsetGetCode,
  requsetVerifyCode,
  requsetResetPassword,
  requsetGetProfile,
  requsetChangeProfile,
  requsetChangePassword,
  requsetChangeAppearance,
  requsetGetAppearance,
  requsetGetSubscription,
  requestFeedbackUpload,
  requestFeedback,
  requsetGetPurchase,
};
